import { Box, Typography, styled } from "@mui/material";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

export const Section = styled("section")(({ theme }) => (props) => ({
  padding: "24px 48px",
  margin: "0px 0",
  border: "1px solid #00000014 ",
  background:
    theme.palette.mode === "light"
      ? theme.palette.background.lightSecondary
      : theme.palette.background.darkSecondary,
  borderRadius: theme.palette.bigBorderRadios,
  [theme.breakpoints.down("md")]: {
    padding: "12px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "6px",
  },
  transition: "0.3s all fade",
}));
export const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  margin: "8px 0",
  padding: theme.spacing(2),
  borderRadius: "8px",
  boxShadow: "-2px 2px 5px 0px rgba(194, 184, 184, 0.75)",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

export const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "#fff",

  flexDirection: "row",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

export const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  [theme.breakpoints.down("xs")]: {
    padding: theme.spacing(1),
  },
}));
export const AccordionContentText = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
}));
export const AccordionText = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: "500",
  color: "#000000",
}));
export const AccordionTextDetails = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: "400",
  color: "#333333",
}));
export const AccordionContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
}));
export const AccordionContentVed = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  padding: "16px 10px",
  boxShadow: "0px 1px 12px 0px #00000014",
  justifyContent: "space-between",
  alignItems: "center",
  textDecoration: "none",
  boxSizing: "border-box",
}));
export const AccordionContentVedItems = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "8px",
}));
export const Icon = styled("img")(({ theme }) => ({}));
